import React from "react";
import style from './ServiceBlock.module.scss'
import { filterMessagesBy } from "../../../../../../../../../../../components/Messages";
import { connect } from "react-redux";

function ServiceBlock({messages, children, id}) {

    const _messages = id ? filterMessagesBy(messages || [], null, null, id) : [];

    let type = '';

    if (_messages.some(m => m.type === 'warning')) type = 'warning';
    if (_messages.some(m => m.type === 'error')) type = 'error';

    return (
        <div className={`${style.block}${type ? ' ' + style[`block--${type}`] : ''}`} id={id}>
            <div className={style.block__icon}>
                {
                    type === 'warning' &&
                    <i
                        className={`fas fa-exclamation-circle ${style.block__icon__item} ${style['block__icon__item--warning']}`}
                    />
                }
                {
                    type === 'error' &&
                    <i
                        className={`fas fa-exclamation-triangle ${style.block__icon__item} ${style['block__icon__item--error']}`}
                    />
                }
            </div>
            <div className={style.block__content}>
                {children}
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    messages: state.deployment.messages,
})

export default connect(mapStateToProps)(ServiceBlock)